import React from "react";
import { useLocation } from "react-router-dom";
import {
    Box,
    IconButton,
    List,
    Typography,
    Divider,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SidebarItem from "../Navbar/SidebarItem";
import { ADMIN_FOOTER_ITEMS, ADMIN_NAV_ITEMS } from "./adminNavConfig";

const SIDEBAR_WIDTH_EXPANDED = 260;
const SIDEBAR_WIDTH_COLLAPSED = 72;

const AdminSidebar = ({ isCollapsed, onToggle, onLogout, isMobile }) => {
    const location = useLocation();

    const isActive = (path, end) => {
        if (end) return location.pathname === path;
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    return (
        <Box
            sx={{
                width: isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED,
                minWidth: isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED,
                alignSelf: "stretch",
                minHeight: "100vh",
                backgroundColor: "#0f172a",
                display: "flex",
                flexDirection: "column",
                transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                overflow: "hidden",
                flexShrink: 0,
                borderRight: "1px solid rgba(255,255,255,0.08)",
            }}
        >
            <Box
                sx={{
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: isCollapsed ? "center" : "space-between",
                    px: isCollapsed ? 0 : 2,
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                }}
            >
                {!isCollapsed && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                        <AdminPanelSettingsIcon sx={{ color: "#38bdf8", fontSize: 22 }} />
                        <Box sx={{ minWidth: 0 }}>
                            <Typography
                                variant="subtitle2"
                                sx={{ color: "white", fontWeight: 700, lineHeight: 1.2 }}
                                noWrap
                            >
                                Platform Admin
                            </Typography>
                            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.55)" }} noWrap>
                                User management
                            </Typography>
                        </Box>
                    </Box>
                )}
                {!isMobile && (
                    <IconButton
                        onClick={onToggle}
                        size="small"
                        sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { bgcolor: "rgba(255,255,255,0.08)" } }}
                    >
                        {isCollapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
                    </IconButton>
                )}
            </Box>

            <List
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    py: 1.5,
                    px: 0,
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                }}
            >
                {ADMIN_NAV_ITEMS.map((item) => (
                    <SidebarItem
                        key={item.id}
                        icon={item.icon}
                        label={item.label}
                        isActive={isActive(item.path, item.end)}
                        isCollapsed={isCollapsed}
                        href={item.path}
                        component="a"
                    />
                ))}
            </List>

            <Divider sx={{ borderColor: "rgba(255,255,255,0.1)" }} />

            <List sx={{ py: 1.5, flexShrink: 0 }}>
                {ADMIN_FOOTER_ITEMS.map((item) =>
                    item.action === "logout" ? (
                        <SidebarItem
                            key={item.id}
                            icon={item.icon}
                            label={item.label}
                            isActive={false}
                            isCollapsed={isCollapsed}
                            onClick={onLogout}
                        />
                    ) : (
                        <SidebarItem
                            key={item.id}
                            icon={item.icon}
                            label={item.label}
                            isActive={false}
                            isCollapsed={isCollapsed}
                            href={item.path}
                            component="a"
                        />
                    )
                )}
            </List>
        </Box>
    );
};

export default AdminSidebar;
export { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED };
